import {createMap} from '@acng/frontend-bounty/collection.js';

const TYPE_NORMAL = 'normal';
const TYPE_FREE = 'free';
const TYPE_EXCLUSIVE = 'exclusive';
const TYPE_VOYEUR = 'voyeur';

/**
 * @type {['normal', 'free', 'exclusive', 'voyeur']}
 */
export const TYPES = [TYPE_NORMAL, TYPE_FREE, TYPE_EXCLUSIVE, TYPE_VOYEUR];

/**
 * @typedef {TYPES[number]} RoomType
 */

/**
 * @typedef {Record<RoomType, number>} LivecamShowPrices
 */

/**
 * @typedef LivecamData
 * @property {string} id
 * @property {boolean} is_online
 * @property {number} fsk
 * @property {LivecamShowPrices} prices
 * @property {Array<keyof LivecamShowPrices>} show_types
 * @property {boolean} toycontrol
 * @property {import('acng/userPool/0fsk.js').FskTrans} motto
 */

/**
 * @type {Map<Amateur["id"], Livecam>}
 */
export const cams = createMap();

const IS_OCCUPIED = 'is_occupied';
const IS_ONLINE = 'is_online';
const HAS_TOYCONTROL = 'toycontrol';

/**
 * @type {[IS_ONLINE, IS_OCCUPIED, HAS_TOYCONTROL]}
 */
export const possibleFlagList = [IS_ONLINE, IS_OCCUPIED, HAS_TOYCONTROL];
